import { ApiKeys } from '@app/constants/api-keys'
import { IEducationGroupLocation } from '@app/interfaces/education/education-group-location'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyEducationApi } from '.'
import { IRtkResponse } from '../../types'

export const educationGroupLocationApi = emptyEducationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getEducationGroupLocations: build.query<
      IRtkResponse<IEducationGroupLocation[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'education/api/v1/education-group-location-dictionary',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IEducationGroupLocation[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.educationGroupLocation,
                id,
              })),
              { type: ApiKeys.educationGroupLocation, id: 'LIST' },
            ]
          : [{ type: ApiKeys.educationGroupLocation, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.educationGroupLocation, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getEducationGroupLocation: build.query<IEducationGroupLocation, number>({
      query: (id) => ({
        url: `education/api/v1/education-group-location-dictionary/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.educationGroupLocation, id },
      ],
    }),
  }),
})

export const {
  useGetEducationGroupLocationsQuery,
  useGetEducationGroupLocationQuery,
} = educationGroupLocationApi
